module.exports = __webpack_public_path__ + "static/media/shape_A.5231ecf2.glb";